// HashtagPopover.jsx
// Displays hashtag information in a popover when clicking on a hashtag

import React from 'react';
import FloatingPanel from './FloatingPanel';
import HashtagInfoCard from './HashtagInfoCard';

/**
 * HashtagPopover
 *
 * Displays hashtag information in a popover when clicking on a hashtag.
 * Shows tag name and related information.
 *
 * @param {Object} props - Component props
 * @param {boolean} props.open - Whether the popover is open
 * @param {HTMLElement} props.anchorEl - Anchor element for the popover
 * @param {{left: number, top: number}|null} [props.anchorPosition] - Optional absolute screen position for caret-based anchoring
 * @param {Function} props.onClose - Callback to close the popover
 * @param {Object} props.tagData - Tag data object
 * @param {string} props.tagData.id - Tag ID
 * @param {string} props.tagData.label - Tag label/name
 * @param {string} props.tagData.docId - Document context (optional)
 * @param {number} [props.nodePos] - Optional: Position of hashtag node in document (for advanced features)
 * @param {Object} [props.view] - Optional: ProseMirror editor view (for advanced features)
 */
export default function HashtagPopover({open, anchorEl, anchorPosition, onClose, tagData, nodePos: _nodePos, view: _view}) {
    if (!tagData) return null;

    return (
        <FloatingPanel
            open={open}
            anchorEl={anchorEl}
            anchorPosition={anchorPosition}
            onClose={onClose}
            width={300}
            sx={{
                border: '1px solid',
                borderColor: 'divider',
                borderRadius: 2,
                boxShadow: 3,
            }}
        >
            <HashtagInfoCard tagData={tagData}/>
        </FloatingPanel>
    );
}

